/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DashboardUseCaseModelCount
 */
export interface DashboardUseCaseModelCount {
  /**
   *
   * @type {string}
   * @memberof DashboardUseCaseModelCount
   */
  month: string;
  /**
   *
   * @type {number}
   * @memberof DashboardUseCaseModelCount
   */
  useCaseCount: number;
}

/**
 * Check if a given object implements the DashboardUseCaseModelCount interface.
 */
export function instanceOfDashboardUseCaseModelCount(value: object): value is DashboardUseCaseModelCount {
  if (!('month' in value) || value['month'] === undefined) return false;
  if (!('useCaseCount' in value) || value['useCaseCount'] === undefined) return false;
  return true;
}

export function DashboardUseCaseModelCountFromJSON(json: any): DashboardUseCaseModelCount {
  return DashboardUseCaseModelCountFromJSONTyped(json, false);
}

export function DashboardUseCaseModelCountFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DashboardUseCaseModelCount {
  if (json == null) {
    return json;
  }
  return {
    month: json['month'],
    useCaseCount: json['use_case_count'],
  };
}

export function DashboardUseCaseModelCountToJSON(value?: DashboardUseCaseModelCount | null): any {
  if (value == null) {
    return value;
  }
  return {
    month: value['month'],
    use_case_count: value['useCaseCount'],
  };
}
